import GsRenderController from './gs-render-controller.ts';
import { SingleGS3DScene } from '../../compontent/single-gs3d-scene.ts';
import { InteractionScene } from '../../compontent/interaction-scene.ts';
import { SplatConfig, SingleSceneConfig, InteractionSceneConfig } from '@/types';
import * as THREE from 'three';

export class GS3dRenderController extends GsRenderController {
  private singleScenes: Map<string, SingleGS3DScene> = new Map();
  private interactionScenes: Map<number, InteractionScene> = new Map();
  async render(
    config: SplatConfig,
    container: HTMLElement,
    wrapper?: HTMLElement,
    onProgress?: (percent: number, percentLabel: string, loaderStatus: number) => void,
  ): Promise<void> {
    console.log('init3DGS using GaussianSplats3D render ', config, container, wrapper, onProgress);

    const splatConfigs = this.getConfig(config);
    console.log('splatConfigs', splatConfigs);
    this.splatConfig = splatConfigs;

    await this.loadMesh(splatConfigs);
    splatConfigs.interactionScenes && this.addInteractionZone(splatConfigs.interactionScenes);
    // 加载高斯泼溅场景
    const singleSceneConfig = this.getSingleSceneConfig(splatConfigs);
    let singleScenePath = config.configPath;
    if (config.cuttingInfoPath) {
      singleScenePath = config.cuttingInfoPath;
    }
    this.singleScenes.set(
      singleScenePath,
      new SingleGS3DScene(this, {
        ...singleSceneConfig,
        onProgress: (process: number, percentLabel: string, loaderStatus: string) => {
          onProgress?.(process, percentLabel, loaderStatus);
        },
      }),
    );
  }

  showInfoPanel(visible: boolean): void {
    console.log('model-controller', visible);
    const { viewer } = this.singleScenes.values().next().value!;
    viewer.viewer.showInfo = visible;
    const infoPanel = document.querySelector('.infoPanel');
    const appDiv = document.getElementById('app');
    viewer.viewer.infoPanel.show();
    if (visible) {
      (infoPanel as HTMLElement).style.display = '';
      appDiv!.appendChild(infoPanel!);
      (infoPanel as HTMLElement).style.marginTop = '100px';
    } else {
      (infoPanel as HTMLElement)!.style.display = 'none';
    }
  }

  animate(playerPosition: THREE.Vector3): void {
    this.interactionScenes.forEach((scene) => {
      scene.checkInteractionZone(playerPosition);
    });
  }

  onWindowResize(): void {}
  /**
   * 获取传入singleScene的值
   * @param {*} splatConfig
   * @returns
   */
  getSingleSceneConfig(splatConfig: SplatConfig): SingleSceneConfig {
    const config: SingleSceneConfig = {
      position: splatConfig.position,
      avatarInfo: splatConfig.avatarInfo,
      showLoadingUI: false,
      progressiveLoad: true,
      rotation: splatConfig.rotation || [0, 0, -1, 0],
      scale: splatConfig.scale,
      gaussianSplats3DOption: {
        sharedMemoryForWorkers: false,
        sphericalHarmonicsDegree: splatConfig?.sphericalHarmonicsDegree >= 0 ? splatConfig.sphericalHarmonicsDegree : 2,
        useBuiltInControls: false,
        threeScene: this.scene,
        selfDrivenMode: false,
        ...splatConfig.gaussianSplats3DOption,
      },
    };
    if (splatConfig.cuttingInfoPath) {
      config.cuttingInfoPath = splatConfig.cuttingInfoPath;
    } else if (splatConfig.url) {
      config.url = splatConfig.url;
    }
    return config;
  }

  addInteractionZone(interactionScenes: InteractionSceneConfig[]): void {
    interactionScenes.forEach((item, index) => {
      this.interactionScenes.set(
        index,
        new InteractionScene(this.scene, {
          ...item,
          onInteractionSceneCallback: ({
            playerPosition,
            cuttingInfoPaths,
          }: {
            playerPosition: { x: number; y: number; z: number };
            cuttingInfoPaths: string[];
          }) => {
            // 检查是否加载了场景
            cuttingInfoPaths.forEach((path) => {
              if (this.singleScenes.get(path)) return;
              if (cuttingInfoPaths.length) {
                this.disposeSingleScene(cuttingInfoPaths);
              }
              // @ts-ignore
              const singleSceneConfig = this.getSingleSceneConfig({
                jsonPath: path,
                cuttingInfoPath: path,
                position: this.splatConfig.position,
                rotation: this.splatConfig.rotation,
                scale: this.splatConfig.scale,
                gaussianSplats3DOption: this.splatConfig.gaussianSplats3DOption,
              });
              // 计算renderOrder，让后续场景显示在第一个场景之下
              const renderOrder = -(this.singleScenes.size + 1);
              this.singleScenes.set(
                path,
                new SingleGS3DScene(this, {
                  avatarPosition: [playerPosition.x, playerPosition.y, playerPosition.z],
                  ...singleSceneConfig,
                  renderOrder,
                }),
              );
            });
          },
        }),
      );
    });
  }
  /**
   * 卸载不需要的场景
   * @param {Array<string>} cuttingInfoPaths - 需要保留的场景路径数组
   */
  disposeSingleScene(cuttingInfoPaths: string[]): void {
    console.log('开始检查并卸载不需要的场景...', cuttingInfoPaths);
    // 将数组转为Set以提高查找效率
    const pathsToKeep = new Set(cuttingInfoPaths);
    const scenesToDispose: Array<{ path: string; scene: SingleGS3DScene }> = [];
    // 遍历当前已加载的场景
    this.singleScenes.forEach((scene, scenePath) => {
      console.log('this.singleScenes', scene, scenePath);
      // 如果当前场景的路径不在需要保留的列表中，标记为需要卸载
      if (!pathsToKeep.has(scenePath)) {
        scenesToDispose.push({ path: scenePath, scene });
        console.log(`标记场景待卸载: ${scenePath}`);
      } else {
        console.log(`保留场景: ${scenePath}`);
      }
    });

    if (!scenesToDispose.length) return;
    const singleScenesIterator = this.singleScenes.entries();
    const singleScenesArray = Array.from(singleScenesIterator);
    console.log('singleScenesArray', singleScenesArray);

    // 卸载标记的场景
    scenesToDispose.forEach(({ path, scene }) => {
      try {
        console.log(`正在卸载场景: ${path}`);

        // 调用场景的dispose方法进行资源清理
        if (scene && typeof scene.dispose === 'function') {
          scene.dispose();
          console.log(`场景 ${path} 资源清理完成`);
        } else {
          console.warn(`场景 ${path} 没有dispose方法`);
        }

        // singleScenesArray.forEach((item, index) => {
        //   if (item[0] === path) {
        //     this.viewer.removeSplatScene(index, false);
        //   }
        // });

        // 从Map中移除该场景
        this.singleScenes.delete(path);
        console.log(`场景 ${path} 已从singleScenes中移除`);
      } catch (error) {
        console.error(`卸载场景 ${path} 时发生错误:`, error);
      }
    });

    console.log(`场景卸载完成，剩余场景数量: ${this.singleScenes.size}`);
    console.log('当前剩余场景:', Array.from(this.singleScenes.keys()));
  }
}
